import { DatePipe } from '@angular/common';
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { LogService } from '../../core/services/log.service';

@Pipe({
  name: 'gridColumnData'
})
export class GridColumnDataPipe implements PipeTransform {
  constructor(@Inject(DatePipe) private datePipe: DatePipe,
              @Inject(LogService) private logService: LogService) { }

  /**
   * Transforms the value based on the column type.
   * @param row The row data containing the value to transform.
   * @param selector The column name or selector.
   * @param type The type of the column (e.g., 'date', 'datetime', 'boolean').
   * @returns The transformed value based on the column type.
   */
  transform(row: any, selector: string, type: string): any {
    let value: any;

    // Strip selector using dot to access nested properties
    if (selector.includes('.')) {
      const keys = selector.split('.');
      value = row;
      for (const key of keys) {
        if (value && key in value) {
          value = value[key];
        } else {
          break;
        }
      }
    } else {
      value = row[selector];
    } 

    let ret = "";

    switch (type) {
      case 'date':
        ret = this.datePipe.transform(value, 'dd/MM/yyyy') || '';
        break;
      case 'datetime':
        ret = this.datePipe.transform(value, 'dd/MM/yyyy HH:mm') || '';
        break;
      case 'boolean':
        ret = value ? 'Sí' : 'No';
        break;
      default:
        ret = value != null ? value.toString() : '';
        break;
    }

    return ret;
  }
}